import { Component, ReactNode } from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { generalReportException } from "@/lib/logs/reportExceptions";

interface AuthErrorBoundaryProps {
  children: ReactNode
}

interface AuthErrorBoundaryState {
  hasError: boolean
  isAuthError: boolean
}

export class AuthErrorBoundary extends Component<AuthErrorBoundaryProps, AuthErrorBoundaryState> {
  constructor(props: AuthErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, isAuthError: false };
  }

  static getDerivedStateFromError(error: Error): AuthErrorBoundaryState {
    // Check if it's an auth-related error
    const isAuthError = error.message.includes("JWT") ||
                       error.message.includes("401") ||
                       error.message.includes("permission denied") ||
                       error.message.includes("Unauthorized");

    return { hasError: true, isAuthError };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    generalReportException(error as Error, { operation: "AuthErrorBoundary.componentDidCatch", additionalData: errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  handleLogin = () => {
    window.location.href = "/uye-ol";
  };

  render() {
    if (this.state.hasError) {
      if (this.state.isAuthError) {
        return (
          <div className="min-h-screen flex items-center justify-center p-4">
            <Alert className="max-w-md">
              <AlertTriangle className="h-4 w-4" />
              <AlertTitle>Oturum Sorunu</AlertTitle>
              <AlertDescription className="mt-2 mb-4">
                Oturumunuzla ilgili bir sorun yaşandı. Lütfen tekrar giriş yapın.
              </AlertDescription>
              <div className="flex gap-2">
                <Button onClick={this.handleLogin} size="sm">
                  Giriş Yap
                </Button>
                <Button variant="outline" onClick={this.handleReload} size="sm">
                  <RefreshCw className="h-4 w-4 mr-2" />
                  Sayfayı Yenile
                </Button>
              </div>
            </Alert>
          </div>
        );
      }

      return (
        <div className="min-h-screen flex items-center justify-center p-4">
          <Alert className="max-w-md">
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>Bir Hata Oluştu</AlertTitle>
            <AlertDescription className="mt-2 mb-4">
              Beklenmeyen bir hata oluştu. Sayfayı yenilemeyi deneyin.
            </AlertDescription>
            <Button variant="outline" onClick={this.handleReload} size="sm">
              <RefreshCw className="h-4 w-4 mr-2" />
              Sayfayı Yenile
            </Button>
          </Alert>
        </div>
      );
    }

    return this.props.children;
  }
}
